import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'device-data-api',
    pluginName: 'SETTINGS',
    entityName: 'DEVICE_DATA_API',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch device data APIs action creators
export const fetchDeviceDataApiInit = () => {
    return crudActions.fetchInit();
};
export const fetchDeviceDataApiStart = () => {
    return crudActions.fetchStart();
};
export const fetchDeviceDataApiSuccess = (count, list) => {
    return crudActions.fetchSuccess(count, list);
};
export const fetchDeviceDataApiFail = () => {
    return crudActions.fetchFail();
};
export const fetchDeviceDataApiCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchDeviceDataApiStart());
        try {
            let countRes = await rest.post("device-data-api/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchDeviceDataApiSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchDeviceDataApiFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch device data APIs."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchDeviceDataApiFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch device data APIs."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}


export const fetchDeviceDataApi = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchDeviceDataApiStart());
        try {
            let listRes = await rest.post("device-data-api/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchDeviceDataApiSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchDeviceDataApiFail());
            return []

        } catch (error) {
            dispatch(fetchDeviceDataApiFail());
            return []
        }
    }
}

// Load device data API action creators
export const loadDeviceDataApiInit = () => {
    return crudActions.loadInit();
};
export const loadDeviceDataApiStart = () => {
    return crudActions.loadStart();
};
export const loadDeviceDataApiSuccess = loadedDeviceDataApi => {
    return crudActions.loadSuccess(loadedDeviceDataApi);
};
export const loadDeviceDataApiFail = error => {
    return crudActions.loadFail(error);
};
export const loadDeviceDataApi = id => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(loadDeviceDataApiStart());
        try {
            let listRes = await rest.post("device-data-api/load", id);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(loadDeviceDataApiSuccess(listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(loadDeviceDataApiFail());
            return null

        } catch (error) {
            dispatch(loadDeviceDataApiFail());
            return null
        }
    }
};

export const createDeviceDataApi = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/device-data-api/create', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully created device data API.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create device data API."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

export const editDeviceDataApi = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/device-data-api/save', params);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `Successfully updated device data API.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit device data API."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}


// Bulk delete device data APIs action creators
export const bulkDeleteDeviceDataApisInit = () => {
    return crudActions.bulkDeleteInit();
};
export const bulkDeleteDeviceDataApisStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteDeviceDataApisSuccess = bulkDeleted => {
    return crudActions.bulkDeleteSuccess(bulkDeleted);
};
export const bulkDeleteDeviceDataApisFail = error => {
    return crudActions.bulkDeleteFail(error);
};
export const bulkDeleteDeviceDataApis = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteDeviceDataApisStart());
        try {
            let res = await rest.post('/device-data-api/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteDeviceDataApisSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted device data APIs.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteDeviceDataApisFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete device data APIs."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete device data APIs."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteDeviceDataApisFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};